import React, { useState, useEffect } from 'react';
import './SocialWidgets.css';
import { FaInstagram, FaFacebook, FaTripadvisor } from 'react-icons/fa';
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

const SocialWidgets = () => {
  const [links, setLinks] = useState({
    facebook: 'https://www.facebook.com/yoamobazurto/', // Default fallback
    instagram: 'https://www.instagram.com/yoamobazurto/', // Default fallback
    whatsapp: 'https://wa.me/573165248933', // Default fallback
    tripadvisor: 'https://www.tripadvisor.com/Restaurant_Review-g147288-d15078699-Reviews-Yo_Amo_Bazurto-Cartagena_Cartagena_District_Bolivar_Department.html', // Default fallback
  });

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const docRef = doc(db, "siteSettings", "socialLinks");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setLinks(docSnap.data());
        } else {
          console.log("No social links document found, using defaults.");
        }
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };

    fetchLinks();
  }, []);

  return (
    <div className="social-widgets">
      <a href={links.instagram} target="_blank" rel="noopener noreferrer">
        <span><FaInstagram /></span>
      </a>
      <a href={links.facebook} target="_blank" rel="noopener noreferrer">
        <span><FaFacebook /></span>
      </a>
      <a href={links.tripadvisor} target="_blank" rel="noopener noreferrer">
        <span><FaTripadvisor /></span>
      </a>
    </div>
  );
};

export default SocialWidgets;